import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { GoogleMap, Marker, InfoWindow, Polyline, LoadScript, StreetViewPanorama } from "@react-google-maps/api";
import "./tour.css";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { motion, AnimatePresence } from "framer-motion";
import { FaPlay } from "react-icons/fa";
//import { FaHeadphones } from "react-icons/fa";
import { DirectionsService, DirectionsRenderer } from "@react-google-maps/api";
import { Translator } from './translator';


const GOOGLE_MAPS_API_KEY = "AIzaSyCOa-Vx3796Zb7OSqUu9qknCyKPwDY6H28";



const Tour_google = () => {
  const { tourID } = useParams();
  const [openDay, setOpenDay] = useState(null); // To track the currently open day
//  const [mapCenter, setMapCenter] = useState(null); // no default center

  const decodeHtmlEntities = (text) => { const textarea = document.createElement("textarea"); textarea.innerHTML = text; return textarea.value; };
  
  const parseBoldText = (text) => {
    return text.split(/(<strong>.*?<\/strong>)/g).map((chunk, i) => {
      if (chunk.startsWith("<strong>") && chunk.endsWith("</strong>")) {
        return (
          <span key={i} style={{ color: "#ff4500", fontWeight: "bold" }}>
            {chunk.replace(/<\/?strong>/g, "")}
          </span>
        );
      }
      return chunk;
    });
  };


  const [tourInfo, setTourInfo] = useState({ Firstsite: "", Lastsite: "",  Duration: "", days: [] });
  const [tour, setTour] = useState({ name: "", details: [] });
  const [coords, setCoords] = useState([]);
  const [popupInfo, setPopupInfo] = useState(null);
  
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tappaimage, setImages] = useState([]);
  const [startingAddress, setStartingAddress] = useState("");
  const [openApprofondimento, setOpenApprofondimento] = useState(null);
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isVideoAvailable, setIsVideoAvailable] = useState(true);
  const [approfondimenti, setApprofondimenti] = useState([]);
  const [approfondimentoIndexByTappa, setApprofondimentoIndexByTappa] = useState({});
  const [routePath, setRoutePath] = useState([]);
  const [directionsResult, setDirectionsResult] = useState(null);
  const [directionsRequest, setDirectionsRequest] = useState(null);
  const mapRef = useRef(null);
  const miniMapRefs = useRef({});
  const hasFitBounds = useRef(false);
  const [showRoute, setShowRoute] = useState(false);
  const initialMapCenter = { lat: 40.8518, lng: 14.2681 }; // Naples
  const [destination, setDestination] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const { translateText, lang } = Translator();
  const [ttsAudioUrl, setTtsAudioUrl] = useState(null);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const globalAudioRef = useRef(null);
  const [nearbyPlaces, setNearbyPlaces] = useState([]);
  const [showAttractions, setShowAttractions] = useState(false);




  const baseText = {
    text1: "Tour:",
    textFallback: "Mappa del tour",
    text2: "Tour digitale, consigliato in",
    text3: "giorno",
    text4: "giorni",
    text5: "Partenza da",
    text6: "arrivo a",
    text7: "Esplorazione ",
    text7_1: "La mia posizione",
    text7_2: "Seleziona la posizione di partenza",
    text7_3: "Seleziona la posizione di destinazione",
    text8: "Nessun titolo",
    text9: "Preparando il tuo tour...",
    text10: "Errore: ",
    text11: "Non sono disponibili dettagli sul tour.",
    text12: "Me",
    text13: "Nascondi percorso",
    text14: "Mostra il percorso consigliato",
    text15: "Caricamento mappa...",
    text16: "Il tuo browser non supporta la riproduzione video.",
    text17: "Caricamento audio...",
    text18: "Ascolta la descrizione",
    text19: "Questa esplorazione ha 1 approfondimento",
    text20: "Nascondere il suo approfondimento",
    text21: "Questa esplorazione ha {count} approfondimenti",
    text22: "Nascondere i suoi {count} approfondimenti", 
    text23: "Guarda video",
    text25: "Impossibile ottenere la posizione attuale.",
    text26: "Ottieni indicazioni stradali",
    text27: "Nessuna sottotitolo disponibile",
    text28: "Nessuna descrizione disponibile",
    text29: "Nessun audio disponibile",
    text30: "Giornata Consigliata:",
    text31: "Nascondi i musei vicini",
    text32: "Mostra i musei vicini",
    text33: "xxxx",
    text34: "xxxx",
    text35: "xxxx",
    text36: "xxxx",
    text37: "xxxx",
    text38: "xxxx",
    text39: "xxxx",
    text40: "xxxx",
    text41: "xxxx",
  };

  // For text23 counter 
  const getTranslated = (key, vars = {}) => {
    let template = translatedText[key] || "";
    Object.entries(vars).forEach(([k, v]) => {
      template = template.replace(`{${k}}`, v);
    });
    return template;
  };

// Translate base text from Italian to the selected language
  const [translatedText, setTranslatedText] = useState(baseText);
  useEffect(() => {
    const translateAll = async () => {
      const entries = Object.entries(baseText);
      const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => [key, await translateText(value)])
      );
      setTranslatedText(Object.fromEntries(translatedEntries));
    };

    translateAll();
  }, [lang]);



  // -----------------------------
  //  Handle tappa translation
  // -----------------------------
  useEffect(() => {
    const retranslateTourDays = async () => {
      if (!tourInfo.days.length) return;
  
      const translatedDays = await Promise.all(
        tourInfo.days.map(async (day) => {
          const [tappaname, title, description, tappaSubtitle] = await Promise.all([
            translateText(day.tappaname),
            translateText(day.title),
            translateText(day.description),
            translateText(day.tappaSubtitle),
          ]);
  
          return {
            ...day,
            tappaname,
            title,
            description,
            tappaSubtitle,
          };
        })
      );
  
      setTourInfo((prev) => ({
        ...prev,
        days: translatedDays,
      }));
    };
  
    retranslateTourDays();
  }, [lang]);
  
  


  const handleNextApprofondimento = (tappaIndex) => {
    const items = approfondimenti.filter((a) => a.tappa === tappaIndex + 1);
    if (!items.length) return;
  
    setApprofondimentoIndexByTappa((prev) => {
      const current = prev[tappaIndex] || 0;
      const next = (current + 1) % items.length;
      return { ...prev, [tappaIndex]: next };
    });
  };



  // -----------------------------
  //  Fetch Polly TTS
  // -----------------------------
  const speakWithPolly = async (text) => {
    try {
      setIsSpeaking(true);
      setTtsAudioUrl(null); // reset before request

      const body = new URLSearchParams({ text, lang });

      const res = await fetch("https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/speak", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: body.toString()
      });
      const audioUrl = await res.text();
  
      setTtsAudioUrl(audioUrl);
    } catch (err) {
      console.error("TTS failed:", err);
      setTtsAudioUrl(null);
    } finally {
      setIsSpeaking(false);
    }
  };


  useEffect(() => {
    setTtsAudioUrl(null);  // Reset audio on language change
  }, [lang]);


  // ------------------------------------
  //  Translate Tour Description for TTS
  // ------------------------------------
  useEffect(() => {
    const generatePollyAudio = async () => {
      if (!tour?.descrizione) return;
  
      const translated = await translateText(tour.descrizione);
      await speakWithPolly(translated);
    };
  
    generatePollyAudio();
  }, [lang, tour?.descrizione]);
  
    
  

  const fetchPollyAudio = async (text) => {
    try {
      setTtsAudioUrl(null); // reset
      const res = await fetch(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/speak?text=${encodeURIComponent(text)}&lang=${lang}`);
      const audioUrl = await res.text();
      setTtsAudioUrl(audioUrl); // audio will be loaded
    } catch (err) {
      console.error("TTS fetch failed:", err);
      setTtsAudioUrl(null);
    }
  };




  


  // -----------------------------
  //  Fetch Images
  // -----------------------------
  const fetchTourMedia = useCallback(async () => {
    try {
      const { data } = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/collectPics?tourID=${tourID}`);
      
        if (data.img && Array.isArray(data.img)) {
          const formattedMedia = data.img.map(file => `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${encodeURIComponent(file)}`);
        setImages(formattedMedia);
        }
    } catch (error) {
        console.error("Error fetching tour media:", error);
    }
}, [tourID]);



useEffect(() => {
  const fetchApprofondimenti = async () => {
    try {
      const { data } = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTecheAPPROFONDIMENTODesc?tourID=${tourID}&lang=${lang}`);
      setApprofondimenti(data);
    } catch (error) {
      console.error("Error fetching approfondimenti:", error);
    }
  };

  fetchApprofondimenti();
}, [tourID, lang]);





// --------------------------------------------------------------
//  Audio Players - Prevent multiple audios from playing at once
// --------------------------------------------------------------
const handlePlay = (audioElement) => {
  if (globalAudioRef.current && globalAudioRef.current !== audioElement) {
    globalAudioRef.current.pause();
  }
  globalAudioRef.current = audioElement;
};








useEffect(() => {
  if (!startingAddress || !destination) return;
  
    // Prevent directions if origin and destination are the same
    if (
      startingAddress.lat === destination.lat &&
      startingAddress.lng === destination.lng
    ) {
      console.warn("Start and end points are the same. Skipping directions.");
      return;
    }
  
  const panelEl = document.getElementById("directionsPanel");
  if (panelEl) panelEl.innerHTML = "";

  const request = {
    origin: startingAddress,
    destination: destination,
    travelMode: "DRIVING"
  };

  setDirectionsResult(null); // 💡 force rerender if route already existed
  setDirectionsRequest(request);
  setShowRoute(true);
}, [startingAddress, destination]);






useEffect(() => {
  if (!navigator.geolocation) {
    console.warn("Geolocation not supported");
    return;
  }
  navigator.geolocation.getCurrentPosition(
    ({ coords }) => {
      setUserLocation({
        lat: coords.latitude,
        lng: coords.longitude
      });
    },
    (err) => {
      console.warn("Could not get user location", err);
    }
  );
}, []);







useEffect(() => {
  const fetchTourData = async () => {
    try {
      const tourResponse = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTecheTourByIDNew?nodeID=${tourID}`);
      const giornoDescResponse = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTecheTappaDesc?tourID=${tourID}&lang=it`);
      
      if (tourResponse.data.tour) {
        const tourData = tourResponse.data.tour;
        
        const translatedFirstsite = await translateText(tourData.Firstsite);
        const translatedLastsite = await translateText(tourData.Lastsite);
        

const giornoDescData = giornoDescResponse.data;

        setTourInfo({
          //Firstsite: tourData.Firstsite || "Unknown",
          //Lastsite: tourData.Lastsite || "Unknown",
          Firstsite: translatedFirstsite,
          Lastsite: translatedLastsite,
          Duration: tourData.duration || "N/A",
          
          days: giornoDescData.map((day, index) => {
            const gpsKey = `tappaGPS${index + 1}`;
           // const gps = tourData[gpsKey] || null;
            
            return {
              title: day.intestazione || `Tappa ${index + 1}`,
              tappaname: day.tappaname || `Tappa ${index + 1}`,
              tappaSubtitle: day.tappaSubtitle || translatedText.text27,
              description: day.desc || translatedText.text28,
              tappaGPS: day.tappaGPS || "40.8358846,14.2487679",                          // Default GPS coordinates for Naples


              tappeAudio: tourData[`it_AudioTappa${index + 1}`] || translatedText.text29,
              tappaimage: day.img ? JSON.parse(day.img) : [],
            //  gps
            };
          })
          
        });
      }
    } catch (error) {
      console.error("Error fetching tour data:", error);
    }
  };

  fetchTourData();
}, [tourID]);

// ---------------------------------------------------------------------------------------
//  Translate Tour Info (Firstsite, Lastsite) everytime the language changes
// ---------------------------------------------------------------------------------------
/*useEffect(() => {
  const retranslateTourInfo = async () => {
    if (!tourInfo.Firstsite || !tourInfo.Lastsite) return;

    const translatedFirstsite = await translateText(tourInfo.Firstsite);
    const translatedLastsite = await translateText(tourInfo.Lastsite);

    setTourInfo((prev) => ({
      ...prev,
      Firstsite: translatedFirstsite,
      Lastsite: translatedLastsite
    }));
  };

  retranslateTourInfo();
}, [lang]);

*/


// ---------------------------------------------------------------------------------------
//  Translate Tour Name, Subheading, and Description everytime the language changes
// ---------------------------------------------------------------------------------------
useEffect(() => {
  const retranslateTour = async () => {
    if (!tour.name && !tour.subheading && !tour.descrizione) return;

    const [name, subheading, descrizione] = await Promise.all([
      translateText(tour.name),
      translateText(tour.subheading),
      translateText(tour.descrizione)
    ]);
    const translatedFirstsite = await translateText(tourInfo.Firstsite);
    const translatedLastsite = await translateText(tourInfo.Lastsite);


    setTour((prev) => ({
      ...prev,
      name,
      subheading,
      descrizione,

      Firstsite: translatedFirstsite,
      Lastsite: translatedLastsite
    }));
  };

  retranslateTour();
}, [lang]);





  // -----------------------------
  //  Fetch Tour views
  // -----------------------------
  useEffect(() => {
  const incrementViews = async () => {
    try {
      await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/addTourViews?tourID=${tourID}`);
    } catch (err) {
      console.error("Failed to update views", err);
    }
  };

  incrementViews();
}, [tourID]);







  // -----------------------------
  //  Fetch Tour Data
  // -----------------------------
  useEffect(() => {
    const fetchTourData = async () => {
      try {
        setLoading(true);
        const [detailsRes, nameRes] = await Promise.all([
          axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getGiornoTappe?tourID=${tourID}`),
          axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTecheTourByIDNew?nodeID=${tourID}&lang=${lang}`)
        ]);

        const tourDetails = Array.isArray(detailsRes.data) ? detailsRes.data : [];
        const tourData = nameRes.data?.tour || {};


/*        const tourName = tourData.Name_it || "Teche Tour";           //printing Teche Tour meaning tour's name is unknown
        const tourSubheading = tourData.Subheading_it || "Teche Tour";
        const tourDescrizione = tourData.Description_it || "No tour description";
*/

        let tourName = tourData.Name_it || "Teche Tour";
        let tourSubheading = tourData.Subheading_it || "Teche Tour";
        let tourDescrizione = tourData.Description_it || "No tour description";

        tourName = await translateText(tourName);
        tourSubheading = await translateText(tourSubheading);
        tourDescrizione = await translateText(tourDescrizione);

        const tourImage = tourData.Image ? `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tourData.Image}` : null;
        const tourAudio = tourData.TourAudio_it ? `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tourData.TourAudio_it}` : null;
        const tourVideo = tourData.TourVideo ? `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tourData.TourVideo}` : null;

        
        setTour({ name: tourName, subheading: tourSubheading, descrizione: tourDescrizione, details: tourDetails, image: tourImage, audio: tourAudio, video: tourVideo });


        


        
        
      
        // fetch images & coords
        await fetchTourMedia();
        await fetchCoordinates(tourDetails, tourData);
        await fetchSiteDetails(tourDetails);
      } catch (err) {
        console.error("Error fetching tour data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTourData();
  }, [tourID, fetchTourMedia]);

  // -----------------------------
  //  Fetch Coordinates
  // -----------------------------
const fetchCoordinates = async (tourDetails, tourData) => {
  try {
    const gpsCoordsList = Object.entries(tourData)
      .filter(([key]) => key.startsWith("tappaGPS"))
      .sort(([a], [b]) => {
        const numA = parseInt(a.replace("tappaGPS", ""));
        const numB = parseInt(b.replace("tappaGPS", ""));
        return numA - numB;
      });

    const enrichedCoords = await Promise.all(
      gpsCoordsList.map(async ([key, value], index) => {
        const [lat, lon] = value.split(",").map(Number);
        const day = index + 1;

        const tappeID = tourDetails?.[index]?.tappe?.[0]; // First tappa for that day
        if (!tappeID) return null;

        try {
          const { data: siteData } = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getSiteCoords?root=${tappeID}`);
          const { data: detailData } = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTappaText?TappaID=${tappeID}`);
          const details = Array.isArray(detailData) ? detailData[0] : {};

          return {
            id: tappeID,
            lat,
            lon,
            day,
            name: siteData?.[0]?.Name?.[0] || "No name",
            description: details?.descrizione || "",
            text: details?.Text || "",
            image: details?.Immagine ? `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${details.Immagine}` : null,
          };
        } catch (err) {
          console.error(`Error fetching site info for ID ${tappeID}`, err);
          
        }
      })
    );

    //setCoords(enrichedCoords.filter(Boolean));

    const validCoords = enrichedCoords.filter(Boolean);
    setCoords(validCoords);

    if (validCoords.length > 0) {
      fetchNearbyPlaces({ lat: validCoords[0].lat, lng: validCoords[0].lon }, "museum");
    }

    
    const pathArray = validCoords.map(({ lat, lon }) => ({ lat, lng: lon }));
    setRoutePath(pathArray);
    


    if (validCoords.length) {
      const avgLat = validCoords.reduce((sum, c) => sum + c.lat, 0) / validCoords.length;
      const avgLng = validCoords.reduce((sum, c) => sum + c.lon, 0) / validCoords.length;
//      setMapCenter({ lat: avgLat, lng: avgLng });
    }
    


    
    
    
  } catch (error) {
    console.error("Error fetching coordinates:", error);
  }
};

  
  
  




// Function to Fetch Nearby Places (We may change it from museums to tourist_attraction)
const fetchNearbyPlaces = (location, type = "museum") => {
  const service = new window.google.maps.places.PlacesService(mapRef.current);
  
  const request = {
    location,
    radius: 1000, // meters
    type
  };

  service.nearbySearch(request, (results, status) => {
    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
      setNearbyPlaces(results);
    } else {
      console.error("Places search failed:", status);
    }
  });
};






  // -----------------------------
  //  Fetch Route
  // -----------------------------



  // -----------------------------
  //  Get Site Details
  // -----------------------------1
  const fetchSiteDetails = async (tappeIDs) => {
    try {
      if (!tappeIDs.length) return;
  
      const idsParam = tappeIDs.join(",");
      const { data } = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTappaText?TappaID=${idsParam}`);
  
      if (Array.isArray(data)) {
        setCoords(prevCoords =>
          prevCoords.map(coord => {
            const detail = data.find(d => d.id === coord.id);
            return {
              ...coord,
              name: detail?.Name || "No name available",
              description: detail?.description || "",
              text: detail?.Text || "",
              image: detail?.Immagine ? `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${detail.Immagine}` : null
            };
          })
        );
      }
    } catch (error) {
      console.error("Error fetching site details:", error);
    }
  };





  // -----------------------------
  //  Handle Map Translation
  // -----------------------------
  useEffect(() => {
    const retranslateMapCoords = async () => {
      if (!coords.length) return;
  
      const updated = await Promise.all(
        coords.map(async (coord) => {
          const [translatedName, translatedDesc] = await Promise.all([
            translateText(coord.name),
            translateText(coord.description),
          ]);
          return {
            ...coord,
            translatedName,
            translatedDesc,
          };
        })
      );
      
  
      setCoords(updated);
    };
  
    retranslateMapCoords();
  }, [lang]);
  
  








  
  

  
  





  // To be checked
  // -----------------------------
  //  Google Maps Helpers
  // -----------------------------
  const getDirection = (site) => {
    const destination = `${site.lat},${site.lon}`;
    const origin = startingAddress ? encodeURIComponent(startingAddress) : "";
    const googleMapsUrl = origin
      ? `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}`
      : `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
    window.open(googleMapsUrl, "_blank");
  };


  
  

  if (loading) return <p>{translatedText.text9}</p>;
  if (error) return <p>{translatedText.text10} {error}</p>;
  if (!tour.details.length) return <p>{translatedText.text11}</p>;










  // -----------------------------
  //  JSX Return
  // -----------------------------
  return (
  <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={["places"]} language={lang} region="IT" loadingElement={<div>{translatedText.text15}</div>} >
  
    <div>
    <h2 style={{ 
        color: "black",
        display: "flex", 
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        textDecorationColor: "GrayText", 
        fontSize: "40px",
        marginBottom: "20px",
        fontWeight: "bold"
    }}>
        {tour.name ? `${translatedText.text1} ${tour.name}` : translatedText.textFallback}
    </h2>


    {tour.subheading && (
    <div>
    <h3 style={{ textAlign: "center", color: "black", fontSize: "30px" }}>{tour.subheading} </h3>
    <div style={{ marginBottom: "20px" }}></div>
    </div>
  )}
  

  


      {/* Tour Main Image */}
      {tour.image && (
          <div className="tour-main-image" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "20px" }}>
              <img 
                  src={tour.image} 
                  alt="Main Tour Image" 
                  style={{ maxWidth: "200%", borderRadius: "10px" , objectFit: "contain"}} 
              />
          </div>
      )}


{/* Tour Intro Audio */}
{tour.audio && (
<div
  style={{
    maxWidth: "900px",
    margin: "0 auto 20px auto",
    padding: "0 20px",
    borderRadius: "12px",
  }}
>
 


</div>
)}










{tour.descrizione && (
<h4 style={{ 
    maxWidth: "900px",
    margin: "0 auto",
    padding: "0 20px",
    textAlign: "center",
    color: "black",
    fontSize: "18px",
    lineHeight: "1.8",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px"
  }}>
  
  {/* Inline Play Icon Button (triggers modal) */}
  {isVideoAvailable && tour.video && (
    <button
    onClick={() => setIsVideoOpen(true)}
    style={{
      backgroundColor: "#324B8E",
      border: "none",
      borderRadius: "50%",
      width: "30px",
      height: "30px",
      fontSize: "14px",
      color: "white",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
    title= {translatedText.text23}
  >
    <FaPlay size={16} />
  </button>
  )}

  {/* Text */}
  <span>{tour.descrizione.replace(/<\/?[^>]+(>|$)/g, "")}</span>
</h4>
)}
<div style={{ maxWidth: "900px", margin: "0 auto 20px auto", padding: "0 20px" }}>
  {!ttsAudioUrl ? (
    <button
      onClick={async () => { const translated = await translateText(tour.descrizione); speakWithPolly(translated); }}
      style={{
        backgroundColor: "#324B8E",
        color: "white",
        padding: "10px 20px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "none",
        cursor: "pointer",
        width: "100%",
      }}
      title="Ascolta"
    >
      {isSpeaking ? translatedText.text17 : `🔊 ${translatedText.text18}`}
    </button>
  ) : (
    <AudioPlayer
      src={ttsAudioUrl}
      autoPlay={false}
      showSkipControls={false}
      showJumpControls={false}
      customAdditionalControls={[]}
      customVolumeControls={["volume"]}
      layout="horizontal-reverse"
      onPlay={(e) => handlePlay(e.target)}
    />
  )}
</div>






<AnimatePresence>
{isVideoOpen && (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.3 }}
    style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000
    }}
    onClick={() => setIsVideoOpen(false)} // closes on background click
  >
    <motion.div
      initial={{ scale: 0.8 }}
      animate={{ scale: 1 }}
      exit={{ scale: 0.8 }}
      transition={{ duration: 0.3 }}
      style={{
        position: "relative",
        width: "80%",
        maxWidth: "800px",
        backgroundColor: "#000",
        borderRadius: "10px",
        overflow: "hidden",
      }}
      onClick={(e) => e.stopPropagation()} // prevent click inside from closing
    >
      <button
        onClick={() => setIsVideoOpen(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          fontSize: "24px",
          background: "none",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          zIndex: 10
        }}
      >
        ✖
      </button>
      <video 
      controls 
      controlsList="nodownload"
      disablePictureInPicture 
      draggable="false"
      style={{ width: "100%", height: "auto" }}>
        <source src={tour.video} type="video/mp4" />
        translatedText.text16
      </video>
    </motion.div>
  </motion.div>
)}
</AnimatePresence>







    

    {/* Google Map */}
    
    





    
    











    <div style={{ display: "flex", height: "500px", gap: "1rem" }}>
  {/* Directions panel */}
  {showRoute && (
  <div
    style={{
      width: "25%",
      height: "100%", // Match parent height
      padding: "1rem",
      backgroundColor: "#f5f5f5",
      borderRadius: "10px",
      display: "flex",
      flexDirection: "column",
      overflowY: "auto", // Make scrollable
      boxSizing: "border-box"
    }}
  >

<select
  onChange={(e) => {
    const value = e.target.value;
    setDirectionsResult(null);

    if (value === "current-location") {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setStartingAddress(userLocation);
        },
        () => {
          alert(translatedText.text25);
        }
      );
    } else {
      const [lat, lng] = value.split(",").map(Number);
      setStartingAddress({ lat, lng });
    }
  }}
  
  defaultValue=""
  style={{
    width: "100%",
    padding: "0.5rem",
    borderRadius: "6px",
    marginBottom: "0.5rem"
  }}
>
  <option value="" disabled>{translatedText.text7_2}</option>
  <option value="current-location">📍 {translatedText.text7_1}</option>
  {coords.map((coord, idx) => (
    <option key={idx} value={`${coord.lat},${coord.lon}`}>
      {translatedText.text7} {coord.day}: {coord.name}
    </option>
  ))}
</select>


<select
      onChange={(e) => {
        const value = e.target.value;
        setDirectionsResult(null);
        if (value === "current-location") {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const userLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              setDestination(userLocation); 
            },
            () => {
              alert(translatedText.text25);
            }
          );
        } else {
            const [lat, lon] = e.target.value.split(",").map(Number);
            setDestination({ lat, lng: lon });
          }
        }}   
        defaultValue=""
        style={{
          width: "100%",
          padding: "0.5rem",
          borderRadius: "6px",
          marginBottom: "0.5rem"
        }}
    >
      <option value="" disabled>{translatedText.text7_3}</option>
      <option value="current-location">📍 {translatedText.text7_1}</option>
      {coords.map((coord, idx) => (
        <option key={idx} value={`${coord.lat},${coord.lon}`}>
          {translatedText.text7} {coord.day}: {coord.name}
        </option>
      ))}
    </select>



    <div
      id="directionsPanel"
      style={{
        flex: "1",
        overflowY: "auto",
        border: "1px solid #ccc",
        borderRadius: "10px",
        backgroundColor: "#fff",
        padding: "10px"
      }}
        />
  </div>
)}



























  <div style={{ position: "relative", width: showRoute ? "75%" : "100%" }}>
    {/* Route Toggle Button */}
    <button
      onClick={() => setShowRoute(!showRoute)}
      style={{
        width: "60%",
        //maxWidth: "200px",
        position: "absolute",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        padding: "10px 16px",
        backgroundColor: "#324B8E",
        color: "white",
        border: "none",
        borderRadius: "6px",
        fontSize: "14px",
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
      }}
    >
      {showRoute ? translatedText.text13 : translatedText.text14}
    </button>


















      <GoogleMap
        //center={initialMapCenter}
        onLoad={(map) => {
          mapRef.current = map;
          if (coords.length) {
            const bounds = new window.google.maps.LatLngBounds();
            coords.forEach(({ lat, lon }) => bounds.extend({ lat, lng: lon }));
            map.fitBounds(bounds);
          }
        }}
        zoom={8}               // zoom lower number is 3
        mapContainerStyle={{
          width: "100%",
          height: "500px",
          border: "2px solid #ccc",
          borderRadius: "10px",
        }}
        
        options={{
          minZoom: 4, // to Prevent zooming out too far
          maxZoom: 20,
          mapTypeControl: true,
          fullscreenControl: true,
        }}

      >
        {/* 1) Render Markers */}
        {coords.map((site) => (
          <Marker
          key={`${site.id}-${site.day}`}
          position={{ lat: site.lat, lng: site.lon }}
          onClick={() => {
            setPopupInfo(site);
//            setHoverInfo(null);
          }}
          label={{
            text: site.name,
            color: "blue",
            fontSize: "14px",
            fontWeight: "bold",
          }}
      
     /*     icon={{
            url: "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=", // 1x1 transparent gif
          }}
*/
        />
        
        ))}
        







        {userLocation && (
  <Marker
    position={userLocation}
    title="Me"
    label={{ text: translatedText.text12, color: "yellow", fontWeight: "bold" }}
    icon={{
      url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
    }}
  />
)}




















                  {/* 3) Popup InfoWindow (on marker click) + Polyline */}
                  {popupInfo && (
            
              <InfoWindow
                position={{ lat: popupInfo.lat, lng: popupInfo.lon }}
                onCloseClick={() => setPopupInfo(null)}
              >
                 <div style={{
    maxWidth: "250px",
    maxHeight: "300px",
    overflowY: "auto",
    padding: "10px",
    fontSize: "14px",
    lineHeight: "1.4",
    borderRadius: "8px",
    boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
  }}>
                  <h4 style={{ margin: "5px 0", fontSize: "16px", fontWeight: "bold", textAlign: "center" }}> {translatedText.text29} {popupInfo.day}</h4>




<h4 style={{ margin: "5px 0", fontSize: "16px", fontWeight: "bold", textAlign: "center" }}>
  <a 
    href="/support" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    {popupInfo.translatedName || popupInfo.name}
  </a>
</h4>






                  {popupInfo.image && (
      <img
        src={popupInfo.image}
        alt="Site"
        style={{ width: "100%", height: "150px", objectFit: "cover", borderRadius: "5px" }}
      />
    )}
    <p style={{ margin: "10px 0" }}>
      {popupInfo.description.length > 100
        ? popupInfo.description.substring(0, 100) + "..."
        : popupInfo.description}
    </p>
    <button onClick={() => getDirection(popupInfo)} style={{
      backgroundColor: "#ff4500",
      color: "white",
      padding: "5px 10px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      display: "block",
      margin: "5px auto"
    }}>
                    🧭 {translatedText.text26}
                  </button>
                </div>
              </InfoWindow>









              
            
          )}





























                      {/* Directions logic */}
                      {showRoute && directionsRequest && (
        <DirectionsService
        key={JSON.stringify(directionsRequest)} // 🆕 Force remount on change
        options={directionsRequest}
        callback={(res, status) => {
          if (status === "OK") {
            setDirectionsResult(res);
          } else {
            console.error("Directions request failed:", status);
          }
        }}
      />
      
      )}



      {showRoute && directionsResult && (
        <DirectionsRenderer
          options={{
            directions: directionsResult,
            suppressMarkers: true,
            panel: document.getElementById("directionsPanel"),
            polylineOptions: {
              strokeColor: "#FF0000",
              strokeOpacity: 0.8,
              strokeWeight: 5,
            },
            preserveViewport: true
          }}
        />
      )}
























        
      </GoogleMap>






      </div>

      </div>



    







{/* Render Tour tappe */}
<div>
<h4 style={{ textAlign: "center", fontSize: "40px", fontWeight: "bold", color: "#000000" }}>{translatedText.text2} {tourInfo.Duration} {tourInfo.Duration === 1 ? translatedText.text3 : translatedText.text4}</h4>
<h4 style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold", color: "#000000" }}>{translatedText.text5} {tourInfo.Firstsite}, {translatedText.text6} {tourInfo.Lastsite}</h4>







    <div>
      {/* Render Tour tappe */}
  
      {tourInfo.days.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          {tourInfo.days.map((day, index) => {
            const filtered = approfondimenti.filter((item) => item.tappa === index + 1);
            const currentIndex = approfondimentoIndexByTappa[index] || 0;
            const currentItem = filtered[currentIndex];
            const isSingle = filtered.length === 1;

            return (
            <div key={index} style={{ width: "80%", textAlign: "center", marginBottom: "0.625rem" }}>
              <button
    


                  // Here opens a tappa
                  onClick={() => {
                    const isSameDay = openDay === index;
                    setOpenDay(isSameDay ? null : index);
                    setOpenApprofondimento(null); // <--- This line closes approfondimento
                    setShowAttractions(false);
                    setTimeout(() => {
  if (mapRef.current && window.google) {
    window.google.maps.event.trigger(mapRef.current, "resize");
  }
}, 30000); // give it time to render

                  }}
                  className="flex justify-between items-center w-full px-4 py-3 bg-[#324b8e] text-white font-bold rounded-lg"

    
                style={{
                  width: "100%",
                  padding: "1rem",
                  fontSize: "1.125rem",
                  fontWeight: "bold",
                  backgroundColor: openDay === index ? "#324b8e" : "#324b8e",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  marginBottom: "5px",
                  //                  transition: "background-color 0.3s",
                  textAlign: "center",       // Center the label text
                  position: "relative"       // Needed for positioning the icon

              
                }}  
              > 


                  
    
                  {/* Mini Map + Description + Image */}
                  
                  {/* Tappa Title */}
                  {openDay === index
                    ? `${translatedText.text7} ${index + 1}: ${day.tappaname || "{translatedText.text8}"}`
                    : `${translatedText.text7} ${index + 1}: ${day.title || "{translatedText.text8}"}`}

                    

                  <span style={{
                position: "absolute",
                right: "20px",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "1.25rem",
                color: "#ffffff",
                filter: "brightness(1.5)", // Optional: boost visibility
                textShadow: "0 0 2px black" // Optional: outline if background is light
              }}>
                {openDay === index ? "-" : "+"}
              </span>





                
        
              </button>


              {openDay === index && (
                <div className="flex flex-col lg:flex-row gap-4 items-stretch">
                  {/* Left: Mini map */}
                  <div className="w-full lg:w-1/3" style={{ position: "relative" }}>























  <GoogleMap
  key={`mini-map-${index}`}
onLoad={(map) => {
  miniMapRefs.current[index] = map;

  const [lat, lng] = day.tappaGPS.split(",").map(Number);
  const center = { lat, lng };

}}

  zoom={14}  
  mapContainerStyle={{aspectRatio: "16 / 9", width: "100%", height: "100%", border: "1px solid #ccc", borderRadius: "clamp(0.5rem, 1vw, 1rem)" }}
    center={{
      lat: parseFloat(day.tappaGPS.split(",")[0]),
      lng: parseFloat(day.tappaGPS.split(",")[1])
    }}
  

    options={{
    minZoom: 4, // 🚫 Prevents zooming out too far
    maxZoom: 20,
    mapTypeControl: true,
    fullscreenControl: true,
  }}
>










  <div style={{
    position: "absolute",
    top: "10px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 10
  }}>

  <button
  onClick={() => {
    const [lat, lng] = day.tappaGPS.split(",").map(Number);
    if (!showAttractions) {
      fetchNearbyPlaces({ lat, lng });
    }
    setShowAttractions(prev => !prev);
  }}
  style={{
    marginBottom: "10px",
    padding: "8px 12px",
    backgroundColor: showAttractions ? "rgba(220, 53, 69, 0.7)" : "rgba(40, 167, 69, 0.7)",  // semi-transparent red or green
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    width: "100%",
    fontWeight: "bold"
  }}
>
  {showAttractions ? translatedText.text31 : translatedText.text32}
</button>
  </div>
















    {/* Marker for the tappa itself */}
    <Marker
      position={{
        lat: parseFloat(day.tappaGPS.split(",")[0]),
        lng: parseFloat(day.tappaGPS.split(",")[1])
      }}
      icon={"http://maps.google.com/mapfiles/ms/icons/red-dot.png"}
    />
        {/* Markers for nearby places */}
        {showAttractions &&
  nearbyPlaces.map((place, index) => (
    <Marker
      key={`nearby-mini-${index}`}
      position={{
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }}
      icon={{
        url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
      }}
      title={place.name}
    />
))}

  </GoogleMap>



                    
                  </div>




























              {/* Center: Audio + Description */}
              <div className="w-full lg:w-1/3">

              {/*   <h3>{`Tappa ${index + 1}`}</h3>   */}

              <h2 style={{ 
                  display: "flex", 
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  color: "black",
                  fontSize: "22px",
                  marginBottom: "20px",
                  fontWeight: "bold"
              }}>{day.tappaSubtitle}</h2>
      
      
      
        {/* Audio player */}
        {day.tappeAudio && day.tappeAudio !==  translatedText.text29 && (
        <AudioPlayer
        src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${day.tappeAudio}`}
        autoPlay={false}
        showSkipControls={false}
        showJumpControls={false}
        customAdditionalControls={[]}
        customVolumeControls={["volume"]}
        layout="horizontal-reverse"
        onPlay={(e) => handlePlay(e.target)}
      />
      )}


      {/* Tappa Description */}
      <div className="text-black text-justify max-w-[50rem] mx-auto leading-relaxed text-[1.0625rem] whitespace-pre-line space-y-4">
      {parseBoldText(decodeHtmlEntities(day.description).replace(/<br\s*\/?>/g, " "))}
      </div>





{/* Approfondimento Section */}
{approfondimenti.filter((item) => item.tappa === index + 1).length > 0 && (
<div style={{ marginTop: "20px" }}>
  <button
    onClick={() =>
      setOpenApprofondimento((prev) => (prev === index ? null : index))
    }
    style={{
                  width: "100%",
                  padding: "1rem",
                  fontSize: "1.125rem",
                  fontWeight: "bold",
                  backgroundColor: openDay === index ? "#324b8e" : "#324b8e",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  marginBottom: "5px",
//                  transition: "background-color 0.3s",
textAlign: "center",       // Center the label text
position: "relative"       // Needed for positioning the icon


      
    }}
  >
    
    
    
    
    
    {(() => {
      const count = approfondimenti.filter((item) => item.tappa === index + 1).length;
      const isOpen = openApprofondimento === index;

      if (count === 1) {
        return isOpen
              ? translatedText.text20
              : translatedText.text19;
          } else {
        return isOpen
              ? getTranslated("text22", { count })
              : getTranslated("text21", { count });

          }
    })()}


    <span style={{
  position: "absolute",
  right: "5%",
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: "1.25rem",
  color: "#ffffff",
  filter: "brightness(1.5)",
  textShadow: "0 0 2px black"
}}>

    {openApprofondimento === index ? "-" : "+"}
    </span>



    </button>
</div>
)}








    </div>



    {/* Right: Image */}
    <div className="w-full lg:w-1/3">
      {day.tappaimage.length > 0 && (
        <img
          src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${day.tappaimage[0]}`}
          alt={`Giorno ${index + 1}`}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "0.625rem",
            maxHeight: "100%", // allow stretch
            aspectRatio: "16 / 9"
          }}
        />
      )}

    </div>



        

  </div>










)}










{openApprofondimento === index && (
  <div
    style={{
      marginTop: "15px",
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "clamp(4px, 1vw, 12px)",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    }}
  >
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        justifyContent: "space-between",
      }}
    >
      { approfondimenti
        .filter((item) => item.tappa === index + 1)
        .map((currentItem, idx, filtered) => {
          


 


          return (
            <div
              key={idx}
              style={{  marginBottom: "0.625rem", width: "100%" 
            }}
            >
              <button
    onClick={() => {
      setApprofondimentoIndexByTappa((prev) => {
        const current = prev[index];
        return {
          ...prev,
          [index]: current === idx ? null : idx,
        };
      });
    }}
    
    style={{
      width: "100%",
      padding: "10px",
      fontWeight: "bold",
      fontSize: "16px",
      backgroundColor: approfondimentoIndexByTappa[index] === idx ? "#ffffff" : "#324b8e",
      color: approfondimentoIndexByTappa[index] === idx ? "#324b8e" : "#ffffff",
      border: "none",
      borderRadius: "0.625rem",
      cursor: "pointer",
      textAlign: "center",
    }}
  >


    <span style={{ marginRight: "10px" }}>{currentItem.title}</span>
    <span style={{ float: "right", fontSize: "1.125rem" }}>
      {approfondimentoIndexByTappa[index] === idx ? "–" : "+"}
    </span>



  </button>








  {approfondimentoIndexByTappa[index] === idx && (
  <div
    style={{
      backgroundColor: "#f9f9f9",
      padding: "1rem",
      borderRadius: "0.625rem",
      boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
      marginTop: "10px",
    }}
  >




            <h4 style={{
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "bold",
              color: "#000000"
            }}>{currentItem.subtitle}</h4>





            {currentItem.image && (
              <img
                src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${currentItem.image}`}
                alt={currentItem.title}
                style={{
                  width: "100%",
                  height: "90%",
                  objectFit: "contain",
                  borderRadius: "0.625rem",
                  marginTop: "15px",
                  backgroundColor: "#005555"
                }}
              />
            )}



{currentItem.audio && (
  <div


className={`mx-auto ${isSingle ? 'w-4/5 max-w-[60%] min-w-[40%]' : 'w-11/12 max-w-[85%] min-w-[50%]'}`}
  >
    <AudioPlayer
      src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${currentItem.audio}`}
      autoPlay={false}
      showSkipControls={false}
      showJumpControls={false}
      customAdditionalControls={[]}
      customVolumeControls={["volume"]}
      layout="horizontal-reverse"
      onPlay={(e) => handlePlay(e.target)}

/>
  </div>
)}

















        <div className="text-black text-justify leading-relaxed text-[17px] whitespace-pre-line space-y-4" style={{
          maxWidth: "800px",
          margin: "0 auto",
        }}>
          {parseBoldText(decodeHtmlEntities(currentItem.description).replace(/<br\s*\/?>/g, " "))}
        </div>


        </div>
)}  




        




          </div>
          );
        }
        )}



    </div>
  </div>
)}




                
            </div>



          )})}
        </div>
      )}
    </div>


</div>





    <style>{`
  @media (max-width: 992px) {
    div[style*="calc(33.33%"] {
      flex: 0 1 calc(50% - 20px);
    }
  }

  @media (max-width: 600px) {
    div[style*="calc(33.33%"] {
      flex: 0 1 100%;
    }
  }
`}</style>
     



     </div>

     


  </LoadScript>

  );

};

export default Tour_google;
